<p-panel [toggleable]="true" toggler="header">
  <ng-template #header>
    <app-panel-header
      titleKey="project.steps.rfq.invitationPreview.previewPriceList.cardTitle.otherImplementation.fees"
      tooltipKey="project.steps.rfq.invitationPreview.previewPriceList.cardTitle.otherImplementation.fees.tooltip"
      [title]="feeCategories.findLabel('other').title"
      [tooltip]="feeCategories.findLabel('other').tooltip"
    ></app-panel-header>
    <span class="panel-header-key-value">
      <span> {{ 'common.total' | transloco }}: </span>
      <span class="font-bold text-gray-300">
        {{ this.grandTotalAllYears() | appCurrency: inputObject() : 0 : 0 }}
      </span>
    </span>
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <form [formGroup]="theForm">
    <ng-container formArrayName="data">
      <p-table [value]="feeRows()" [rowTrackBy]="trackByIndex">
        <ng-template #header>
          <tr>
            <th>{{ 'integration.other.title' | transloco }}</th>
            @for (year of inputObject().scopeYears; track year) {
              <th class="w-[9%] text-right">{{ 'common.year' | transloco }} {{ year }}</th>
            }

            <th class="w-[9%] text-right">{{ 'common.total' | transloco }}</th>
            <th class="w-[3%] text-right">{{ 'common.comment' | transloco }}</th>
          </tr>
        </ng-template>

        <ng-template #body let-row let-rowIndex="rowIndex">
          <tr [formGroupName]="rowIndex">
            <td>
              {{
                getIntegrationOtherFee(row.data.directusDropdownOtherFeeUuid) | translateDirectus
              }}
            </td>

            <ng-container formArrayName="yearlyItemFees">
              @for (fee of row.data.yearlyItemFees; track $index) {
                <td [formGroupName]="$index" class="w-[9%] text-right">
                  <app-form-field-number
                    [id]="'fee-' + $index"
                    [icon]="extractCurrencyIcon(inputObject().currencyCode)"
                    fieldName="feePerUnit"
                    [locale]="inputObject().locale"
                    [showButtons]="false"
                    [mode]="'integer'"
                    [isReadOnly]="isReadOnly()"
                  ></app-form-field-number>
                </td>
              }
            </ng-container>

            <td class="w-[9%] font-semibold text-right">
              {{ row.totalAcrossScope | appCurrency: inputObject() : 0 : 0 }}
            </td>
            <td class="w-[3%] text-right">
              <app-comment-modal-button
                [isReadOnly]="isReadOnly()"
                [control]="theForm.get('data.' + rowIndex + '.comment')"
              ></app-comment-modal-button>
            </td>
          </tr>
        </ng-template>

        <ng-template #footer>
          <tr class="font-bold">
            <td>{{ 'common.total' | transloco }}</td>
            @for (year of inputObject().scopeYears; track year; let i = $index) {
              <td class="w-[9%] text-right">
                {{ columnTotalsPerYear()[i] | appCurrency: inputObject() : 0 : 0 }}
              </td>
            }
            <td class="w-[9%] text-right">
              {{ grandTotalAllYears() | appCurrency: inputObject() : 0 : 0 }}
            </td>
            <td class="w-[3%]"></td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>

    @if (!isReadOnly() && theForm.valid && hasChanges()) {
      <div class="flex justify-end gap-2 mt-4">
        <app-project-step-save-button
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (clicked)="onSubmit()"
        ></app-project-step-save-button>
      </div>
    }
  </form>
</p-panel>
